import React from 'react';

import {
  coreUtils,
} from '@gymcloud/core';

import {
  Button,
} from 'web-components';

import {
  Flex,
  Text,
  SVG,
} from 'web-styled';

import Video from './Video';
import * as S from './styled';

const isFloat = (n: number) => Number(n) === n && n % 1 !== 0;
const getAmount = (amount: number): string[] => {
  if (!amount) return ['0'];

  return String(isFloat(amount)
    ? amount.toFixed(2)
    : amount).split('.');
};

type Props = {
  name: string,
  amount: number,
  interval?: string,
  currency: string,
  description: string,
  imageUrl?: string | null,
  videoUrl?: string | null,
  isSelected?: boolean,
  onBuy?: { (): void },
  onSubscribe?: { (): void },
};

const Item = ({
  name,
  amount,
  interval,
  currency,
  description,
  imageUrl,
  videoUrl,
  isSelected,
  onBuy,
  onSubscribe,
}: Props) => {
  const amounts = getAmount(amount);

  return (
    <S.Item isSelected={isSelected} style={{ minHeight: interval ? 0 : 190 }}>
      {imageUrl && !videoUrl && (
        <S.ItemImage
          style={{
            backgroundImage: `url(${imageUrl})`,
          }}
        />
      )}
      {videoUrl && (
        <Video
          src={videoUrl}
          preview={imageUrl || ''}
        />
      )}
      <S.ItemData>
        <Flex column width="60%">
          <S.ItemTitle className="ItemTitle">
            {name}
            {interval && (
              <>
                <span>{`${interval === 'month' ? 'Monthly' : 'Annual'} Plan`}</span>
                {isSelected && <SVG.Checked />}
              </>
            )}
          </S.ItemTitle>
          <Text
            size="1.28em"
            color="#797979"
            lineHeight="1.4em"
          >
            {description}
          </Text>
        </Flex>
        <Flex
          column
          align="flex-end"
          spacing={15}
        >
          <S.ItemPrice className="ItemPrice">
            <b>
              {coreUtils.getCurrencySymbol(currency || '$')}
              {amounts[0] || ''}
              {amounts[1] ? `.${amounts[1]}` : ''}
            </b>
            <Text
              size="1.28em"
              weight="600"
            >
              {interval ? `per ${interval}` : 'per item'}
            </Text>
          </S.ItemPrice>

          {onSubscribe && (
            <Button
              ghost
              appearance="primary"
              onClick={onSubscribe}
            >
              {isSelected ? 'Manage' : 'Subscribe'}
            </Button>
          )}

          {onBuy && (
            <Button
              ghost
              appearance="primary"
              onClick={onBuy}
            >
              Add to Cart
            </Button>
          )}
        </Flex>
      </S.ItemData>
    </S.Item>
  );
};

export default Item;
